import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  private messageSource = new BehaviorSubject('default message');
  currentMessage = this.messageSource.asObservable();

  private moduleSource = new BehaviorSubject('Debe seleccionar un módulo');
  currentModule = this.moduleSource.asObservable();

  private userLogged = new BehaviorSubject('');
  currentUser = this.userLogged.asObservable();


  constructor() { }

  changeProgramId(programId: string) {
    this.messageSource.next(programId)
  }

  changeModuleId(moduleId: string) {
    this.moduleSource.next(moduleId)
  }

  userLoggedSession(objUser: object) {
    this.userLogged.next(JSON.stringify(objUser))
  }

}
